import { jsx as l } from "react/jsx-runtime";
import { forwardRef as m, useContext as p, useRef as a, useImperativeHandle as b, useEffect as v } from "react";
import x from "clsx";
import { ExpandableContext as E } from "./expandable-context.js";
import { animateHidden as I, IS_ANDROID as h } from "../../utils.js";
import C from "../expandable.module.css.js";
const N = m(function({ className: f, ...i }, u) {
  const { open: e, setOpen: n, contentId: c, titleId: s } = p(E), r = a(null), o = a(e);
  return b(u, () => r.current), v(() => {
    if (!r.current)
      return;
    const t = r.current, d = () => n == null ? void 0 : n(!0);
    return o.current === e ? e ? t.removeAttribute("hidden") : t.setAttribute("hidden", "until-found") : (o.current = e, I(t, e ? !1 : "until-found")), t.addEventListener("beforematch", d), () => t.removeEventListener("beforematch", d);
  }, [e, o, n]), /* @__PURE__ */ l(
    "div",
    {
      ...i,
      "aria-hidden": !e,
      "aria-labelledby": h ? void 0 : s,
      className: x(C.content, f),
      id: i.id || c,
      role: "group",
      ref: r
    }
  );
});
export {
  N as ExpandableContent
};
//# sourceMappingURL=expandable-content.js.map
